import * as React from "react"
import {Box, Typography} from "@mui/material";

import {PriceEvolutionShowMinMax} from "../../../@signals";
import MinMaxButton from "./MinMaxButton";
import PriceSwitch from "./PriceSwitch";
import LegendSwitch from "./LegendSwitch";
import ChartMetric from "./Metric";


export default function PriceEvolutionChartSubtitle(props) {
	const {
		isSplitBySku, isPercentage, useActualPrice, showLegend, showRRSP, handleChangePrice, handleChangeLegend, handleChangeMetric, handleChangeShowRRSP
	} = props

	return <Box display="flex" flexDirection="column">
		<Typography>
			Please note axis does not start at zero
		</Typography>
		<Box display="flex" gap={4} justifyContent="flex-end" alignItems="center" position="absolute" right={20} mt={2}>
			{ !!useActualPrice && <MinMaxButton isPercentage={isPercentage}/>}
			
			{ PriceEvolutionShowMinMax.value !== true && <>
				<LegendSwitch
					value={showLegend}
					onChange={handleChangeLegend}
				/>

				<PriceSwitch
					value={useActualPrice}
					onChange={handleChangePrice}
					isPercentage={isPercentage}
				/>

			</> }

			<ChartMetric
				onChange={handleChangeMetric}
			/>
		</Box>
	</Box>
}